import React from 'react';
import PropTypes from 'prop-types';
import { useTableOneColumns } from '../hooks/useTableColumns';
import BaseTable from '../../../components/BaseTable/BaseTable';

const TableOne = ({ data, isLoading, error, subBranchDashboard, showNoStoreSelected = false }) => {
  const columns = useTableOneColumns({ subBranchDashboard });

  return (
    <BaseTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      error={error}
      showNoStoreSelected={showNoStoreSelected}
    />
  );
};

TableOne.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
  subBranchDashboard: PropTypes.bool,
  showNoStoreSelected: PropTypes.bool,
};

export default React.memo(TableOne);
